import { render, staticRenderFns } from "./CampingAbout.vue?vue&type=template&id=2cb9a720&"
import script from "./CampingAbout.vue?vue&type=script&lang=js&"
export * from "./CampingAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports